export const WT_LOCAL_STORAGE_KEY = 'isInWorkingTime';
export const WE_LOCAL_STORAGE_KEY = 'isInExtraWorkingTime';
export const MODAL_OPEN_LOCAL_STORAGE_KEY = 'isModalOpen';
